import { render } from "./credit_create.vue?vue&type=template&id=0ffed960&scoped=true"
import script from "./credit_create.vue?vue&type=script&lang=js"
export * from "./credit_create.vue?vue&type=script&lang=js"

import "./credit_create.vue?vue&type=style&index=0&id=0ffed960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ffed960"]])

export default __exports__